import app from '@frontastic/catwalk/src/js/app/app';
import { useCartContext } from '../provider/cart/CartContext';
import { useState } from 'react';

const getErrorMessage = (error) => {
  if (error instanceof Error) {
    if (error.message.startsWith('Error in API Proxy request')) {
      return 'An error occurred while processing your request. Please try again later.';
    }

    return error.message;
  }

  if (typeof error === 'object' && error !== null && typeof error.message === 'string') {
    return error.message;
  }

  return 'An unknown error occurred while processing your request. Please try again later.';
};

export const useGiftCardActions = () => {
  const { setCartData } = useCartContext();
  const [loadingRemoveGift, setLoadingRemoveGift] = useState(false);

  const applyGiftVoucher = (payload, setStatus, setLoading) => {
    setLoading(true);
    app.getApi().request(
      'POST',
      'Apg.GiftCard.Post.Apply.VoucherLineItem',
      { ownErrorHandler: true },
      payload,
      (data) => {
        setLoading(false);
        setCartData(data);
        setStatus({
          type: 'success',
        });
      },
      (error) => {
        setLoading(false);
        setStatus({
          type: 'error',
          message: getErrorMessage(error),
          shown: true,
        });
      },
    );
  };

  const removeGiftCard = (voucherCode, setStatus) => {
    setLoadingRemoveGift(true);
    app.getApi().request(
      'POST',
      'Apg.GiftCard.Post.Remove.AppliedVoucher',
      { ownErrorHandler: true },
      { voucherCode },
      (data) => {
        setLoadingRemoveGift(false);
        setCartData(data);
        setStatus({
          type: null,
          shown: false,
        });
      },
      (error) => {
        setLoadingRemoveGift(false);
        app.store.dispatch({
          type: 'CartApi.Cart.add.error',
          error: error,
        });
      },
    );
  };

  return {
    loadingRemoveGift,
    applyGiftVoucher,
    removeGiftCard,
  };
};
